import {t} from 'i18next';

const Constants = {
    DATE_GET_REQUEST_FORMAT: 'YYYY-MM-DD',
    DATE_TIME_FORMAT_ISO: 'dd-MM-yyyy HH:mm:ss',
    DATE_TIME_ISO_FORMAT_PLACEHOLDER: 'dd-mm-rrrr GG:MM:SS',
    DATE_TIME_GG_MM_FORMAT_PLACEHOLDER: 'dd-mm-rrrr GG:MM',
    DATE_TIME_FORMAT: 'YYYY-MM-DD HH:mm:ss',
    TIME_FORMAT: 'HH:mm:ss',
    DATE_FORMAT: 'YYYY-MM-DD',
    DATE_FORMAT_MONTH: 'YYYY-MM',
    SIMPLE_DATE_FORMAT: 'DD-MM-YYYY',
    BOOLEAN_OPTIONS: [
        {value: true, label: 'Tak'},
        {value: false, label: 'Nie'},
    ],
    BOOLEAN_OPTIONS_ONLY_TRUE: [{value: true, label: 'Tak'}],
    IMAGE_EXTS: '.gif,.jpg,.jpeg,.png',
    SC_MAX_RESULT: 99999,
    IMAGE_MAX_SIZE: 10000000,
    PROTOCOL_REPORT_MAX_SIZE: 100000000,
    SUCCESS_MSG_LIFE: 15000,
    INTEGER_MAX_VALUE: 2147483647,
    ERROR_MSG_LIFE: 15000,
    MAX_IMAGE_SIZE: 500000,
    INAVALID_FILE_SIZE_MESSAGE_SUMMARY: 'Załadowanie pliku nie powiodło się. Maksymalny rozmiar pliku to 500 KB.',
    INAVALID_FILE_SIZE_MESSAGE_DETAILS: '',
    monthOpt: [
        {enumValue: 1, label: 'Styczeń'},
        {enumValue: 2, label: 'Luty'},
        {enumValue: 3, label: 'Marzec'},
        {enumValue: 4, label: 'Kwiecień'},
        {enumValue: 5, label: 'Maj'},
        {enumValue: 6, label: 'Czerwiec'},
        {enumValue: 7, label: 'Lipiec'},
        {enumValue: 8, label: 'Sierpień'},
        {enumValue: 9, label: 'Wrzesień'},
        {enumValue: 10, label: 'Październik'},
        {enumValue: 11, label: 'Listopad'},
        {enumValue: 12, label: 'Grudzień'},
    ],
    initialLatitude: 54.312795,
    initialLongitude: 18.651946,
};

export default Constants;
